import { createRoutine } from 'redux-saga-routines';

export const createKpiTemplate = createRoutine('CREATE_KPI_TEMPLATE');
export const fetchAllKpiTemplates = createRoutine('FETCH_ALL_KPI_TEMPLATES');
export const fetchKpiTemplateById = createRoutine('FETCH_KPI_TEMPLATE_BY_ID');
export const updateKpiTemplate = createRoutine('UPDATE_KPI_TEMPLATE');
export const archiveKpiTemplate = createRoutine('ARCHIVE_KPI_TEMPLATE');
export const duplicateKpiTemplate = createRoutine('DUPLICATE_KPI_TEMPLATE');
